// import { pageTypes } from 'config/pageTypes';
import SGPHeroImage from 'assets/images/sgp/hero/sgp-general-hero-optimized.webp';
import furniture from 'assets/images/sgp/5x15/furniture.svg'
import musicalInstrument from 'assets/images/sgp/5x15/musicalInstrument.svg'
import paperwork from 'assets/images/sgp/5x15/paperwork.svg'
import AltContentImage from 'assets/images/sgp/5x5/alt-content-image.webp';
import FeaturedContent1 from 'assets/images/sgp/5x5/storage-unit-size.webp';
import Postcovers from 'assets/images/sgp/5x5/how-storage-unit-measured.webp';
import featured from 'assets/images/sgp/10x15/10x10-storage.webp';
import bike from 'assets/images/sgp/10x15/10x15-storage-unit.webp';
import electricity from 'assets/images/sgp/5x15/electricity.svg'
import garage from 'assets/images/sgp/5x15/garage.svg'
import home from 'assets/images/sgp/5x15/home.svg'
import moving from 'assets/images/sgp/5x15/moving.svg'
import savemoney from 'assets/images/sgp/5x15/save-money.svg'
import shop from 'assets/images/sgp/5x15/shop.svg'
import { pageTypes } from 'config/pageTypes';
import fullWidthColumnTableImage from 'assets/images/sgp/fourColumnTable.svg';
import threeColumnTableImage from 'assets/images/sgp/threeColumnTable.svg';

const pageType = 'SGP';
const reviews = [
	{
		reviewTitle: 'Accomodating Storage Space',
		reviewRating: 5,
		reviewText:
			"When I got there the manager had just sold the last 5x5 unit which I had reserved so he upgraded me to a 5x15 for the same price I was suppose to get the 5x5 for, which worked out great because I was able to keep my bed in storage too rather than throw it out. The manager is hysterical too!!",
		reviewerInitials: 'HB',
		reviewerName: 'Heather Bello',
		// reviewDate: 'May 23, 2015',
		link: 'https://www.trustpilot.com/reviews/55609cee0000ff0002e7f1e6',
	},
	{
		reviewTitle: 'Affordable Units',
		reviewRating: 5,
		reviewText:
			"It was easy to reserve a unit; not only that, but the process was quick!",
		reviewerInitials: 'LJ',
		reviewerName: 'LAVERNE JORDAN',
		// reviewDate: 'Sep 27, 2025',
		link: 'https://www.trustpilot.com/reviews/68d70059b9e08307719b44c6',
	},
	{
		reviewTitle: 'Great experience!',
		reviewRating: 5,
		reviewText:
			"Danielle was everything you’d want in a location manager - knowledgeable, friendly, efficient and easy to work with. She called a few minutes after I reserved a unit online to welcome me and coordinate an onsite visit, and when we came in she immediately remembered who we were, and the process of finalizing our rental was fast and pleasant.",
		reviewerInitials: 'SU',
		reviewerName: 'Susan',
		// reviewDate: 'Sep 19, 2025',
		link: 'https://www.trustpilot.com/reviews/68cd7ad9efda0d4d64ecc136',
	},
	{
		reviewTitle: 'Rhonda Wellde',
		reviewRating: 5,
		reviewText:
			"The customer service agent, Eric, made the entire reservation process so effortless! He was very professional, so kind, and incredibly helpful in locating the exact storage unit we needed for our upcoming move for the best possible deal available! I HIGHLY recommend this awesome service!",
		reviewerInitials: 'RW',
		reviewerName: 'Rhonda Wellde',
		// reviewDate: 'Aug 23, 2025',
		link: 'https://www.trustpilot.com/reviews/68a8b69f4f74570e032dc529',
	},
];
const threePanelBlock = {
	props: {
		title: 'What Can Fit in a 5x15 Storage Unit?',
		background: 'gray',
		type: 'three-panel',
		pageType: 'SGP',
		content: [
			{
				image: furniture,
				description:
					'### Household Items: \n\n * 1-2 bedroom apartment contents \n\n * Living room furniture (sofa, chairs, coffee table) \n\n * Bedroom set (bed, dresser, nightstand) \n\n * Small appliances (washer, dryer, refrigerator) \n\n * 20-40 boxes of personal belongings  \n\n * Seasonal decorations and clothing',
			},
			{
				image: musicalInstrument,
				description:
					'### Specialty Storage: \n\n  * [Motorcycles or small vehicles](https://www.sparefoot.com/blog/how-to-winterize-and-store-your-motorcycle) \n\n * Kayaks, canoes, or small boats \n\n * Exercise equipment and weights \n\n * Musical instruments and amplifiers \n\n * Art supplies and craft collections',
			},
			{
				image: paperwork,
				description:
					'### Small Business Applications: \n\n * Retail inventory for online sellers \n\n * Office furniture and supplies \n\n * Seasonal merchandise \n\n * Equipment for service businesses',
			},
		],
	},
};
const fullWidthTable = {
	isFullWidth: true,
	image: fullWidthColumnTableImage,
	title: 'Is a 10x10 or 5x15 Storage Unit Better?',
	description:
		'Both units offer 75-100 square feet, but serve different needs',
	slug: 'size-chart-section',
	columnWidths: [1, 3],
	pageType,
	headers: [
		{
			label: 'Feature',
			key: 'Feature',
		},
		{
			label: '5x15 Unit',
			key: '5x15 Unit',
		},
		{
			label: '10x10 Unit',
			key: '10x10 Unit',
		},
		{
			label: 'Best For',
			key: 'Best For',
		},
	],
	rows: [
		{
			Feature: {
				type: 'markdown',
				markdown: '**Shape**',
			},
			'5x15 Unit': 'Long & narrow',
			'10x10 Unit': 'Square',
			'Best For': '5x15: Furniture, appliances',
		},
		{
			Feature: {
				type: 'markdown',
				markdown: '**Organization**',
			},
			'5x15 Unit': 'Zone-based',
			'10x10 Unit': 'Open layout',
			'Best For': '10x10: Boxes, general items',
		},
		{
			Feature: {
				type: 'markdown',
				markdown: '**Furniture Storage**',
			},
			'5x15 Unit': 'Excellent',
			'10x10 Unit': 'Good',
			'Best For': '5x15: Long pieces fit better',
		},
		{
			Feature: {
				type: 'markdown',
				markdown: '**Access**',
			},
			'5x15 Unit': 'Single-file',
			'10x10 Unit': 'Multiple angles',
			'Best For': '10x10: Frequent access',
		},
		{
			Feature: {
				type: 'markdown',
				markdown: '**Cost**',
			},
			'5x15 Unit': 'Often slightly less',
			'10x10 Unit': 'Standard pricing',
			'Best For': '5x15: Budget-conscious',
		},
	],
};
const faqs = [
	{
		question: 'How big is a 5x15 storage unit?',
		answer: "5x15 storage unit measures 5 feet wide by 15 feet long, providing 75 square feet of floor space and typically 600-750 cubic feet of total volume. What makes this size unique is its rectangular shape - it's narrow but deep, which works perfectly for many storage situations. The 15-foot length allows you to store long items like sofas, mattresses, and appliances without having to position them diagonally or disassemble them.",
	},
	{
		question:
			'What can fit in a 5x15 storage unit compared to smaller options?',
		answer: '5x15 storage unit can accommodate significantly more than smaller alternatives like 5x5 or 5x10 units. Common items that fit well include complete bedroom sets, living room furniture, washers and dryers, refrigerators, exercise equipment, motorcycles, kayaks, and business inventory. \n\nThe key advantage over smaller units is that you can store items at their full size without disassembling furniture or cramming everything together. Many customers use these units during apartment transitions, seasonal storage needs, or as extra closet space for growing households. The linear layout also makes it easy to access items stored in the back by creating a clear pathway down the center.',
	},
	{
		question: 'Is a 10x10 or a 5x15 storage unit better for my needs?',
		answer: "Both 5x15 and 10x10 storage units offer similar square footage (75-100 sq ft), but they serve different storage styles and needs. A 5x15 storage unit excels for furniture storage, long items, and linear organization. If you're storing couches, mattresses, appliances, or items that benefit from being arranged in a line, the 5x15 works beautifully. It also tends to cost slightly less in many markets.\n\nA 10x10 unit offers more flexibility for accessing items from multiple angles. It works better if you need frequent access to various stored items. The square shape accommodates different arrangement styles and can feel less cramped when moving around inside. \n\nChoose 5x15 if you're storing furniture, have long items, prefer organized zones, or want to save money. Choose 10x10 if you need flexible access, store mostly boxes, or prefer more open maneuvering space. Consider your stored items' shapes and how often you'll access them.",
	},
];
const iconContentBlock1 = {
	headerContent: {
		prefix: '',
		title: 'Why a 5x15 Storage Unit Is Your Smart Storage Choice',
		description:
			'A 5x15 storage unit delivers impressive versatility and value for medium-sized storage needs:',
	},
	itemsContent: {
		items: [
			{
				icon: garage,
				title: '### Smart Space Design',
				description:
					'Narrow 5-foot width with 15-foot depth maximizes storage while encouraging organization',
			},
			{
				icon: savemoney,
				title: '### Budget-Conscious Value',
				description:
					'75 square feet offers more space than smaller units without premium pricing',
			},
			{
				icon: home,
				title: '### Life Transition Ready',
				description:
					'Perfect for 1-2 bedroom apartment contents, college storage, or seasonal cleanouts',
			},
			{
				icon: shop,
				title: '### Business-Friendly',
				description:
					'Ideal for inventory, supplies, and merchandise with excellent organization potential',
			},
			{
				icon: moving,
				title: '#### Strategic Access',
				description:
					'Deep layout allows front-to-back zoning for easy navigation and item retrieval',
			},
			{
				icon: electricity,
				title: '#### Upgrade Ready',
				description:
					'Level up your 5x15 by selecting a unit with climate control, electricity with power outlets, and more. ',
			},
		],
	},
};
const alternateContentData1 = {
	title: 'Looking for a Small Storage Unit?',
	description:
		'If you’re here, chances are that you’re looking for a small storage unit to give your stuff a new home. Lucky for you, SpareFoot has a variety of storage unit sizes to suit your small storage needs. Here’s your Goldilocks storage unit menu to help you find the best storage space:',
	additionalProps: {
		paragraph: {
			color: 'black',
		},
	},
	content: [
		{
			title: '',
			image: AltContentImage,
			description:
				'**Medium Units:** 10x10, 10x15, 5x15 (*you are here*)\n\n' +
				'**Small Units:** 5x5, 5x10, Mini storage, Storage lockers\n\n' +
				'**Large Units:** 10x20, 10x25, 10x30',
		},
	],
};

const threeColumnTable = {
	title: '5x15 Storage Unit Average Cost',
	image: threeColumnTableImage,
	description:
		'5x15 storage unit pricing will vary based on location, lease term, seasonal demand, and more. The table below breaks down average pricing across different scenarios to help you budget for your storage needs.',
	type: 'sizeChart',
	slug: 'size-chart-section',
	pageType: pageTypes.SGP,
	headers: [
		{
			label: 'Area',
			key: 'Area',
		},
		{
			label: 'Monthly Range',
			key: 'Monthly Range',
		},
		{
			label: 'Overall Average',
			key: 'Overall Average',
		},
	],
	rows: [
		{
			Area: 'City',
			'Monthly Range': '$60-$150',
			'Overall Average': '$105',
		},
		{
			Area: 'Suburbs',
			'Monthly Range': '$45-$120',
			'Overall Average': '$85',
		},
		{
			Area: 'Rural',
			'Monthly Range': '$35-$90',
			'Overall Average': '$65',
		},
	],
};

export const content5x15 = {
	type: '5x15',
	pageType: pageTypes.SGP,
	sections: [
		{
			title: '5X15 Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: '5x15-storage-hero',
					pageType: 'SGP',
					background: 'lighterYellow',
					props: {
						content: {
							title: '5x15 Storage Units: Smart Space for Medium Storage Needs',
							pageType: 'SGP',
							inputLabel: 'Find Your Ideal 5x15 Storage Unit',
							image: SGPHeroImage,
							description:
								"Meet the 5x15 storage unit. Think of it as your secret closet that happens to be 75 square feet. This sleek, corridor-style space works like magic for the stuff that's too good to toss but too much for your [ studio or apartment.](https://www.sparefoot.com/blog/apartment-storage-ideas) Discover budget-friendly 5x15 units in your neighborhood and finally exhale in your own home again.",
							CTAText: 'Find Storage',
						},
					},
				},
			],
		},
		{
			title: 'nearby units',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Facilities Near',
					},
				},
			],
		},
		{
			title: 'Alternate Content Section 1',
			modules: [
				{
					type: 'alternatingContent',
					id: 'AlternatContent1',
					props: {
						props: alternateContentData1,
					},
				},
			],
		},

		{
			title: 'Icon Content Block 1',
			background: 'gray',
			modules: [
				{
					type: 'IconContentBlock',
					id: '5x10IconContentBlock1',
					props: iconContentBlock1,
				},
			],
		},

		// // Small But Mighty: 5x15 Storage Unit Size Guide
		{
			title: 'Size Guide',
			modules: [
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						title: 'Small But Mighty: 5x15 Storage Unit Size Guide',
						content: [
							"A 5x15 storage unit provides 75 square feet of floor space and typically 600-750 cubic feet of total storage space. Here's how big a 5x15 storage unit is:",
						],
					},
				},
				{
					type: 'sizeChart',
					pageType: 'SGP',
					props: {
						pageType: 'SGP',
						tableType: 'specialType',
						headers: [
							{
								label: 'Dimension',
								key: 'dimension',
							},
							{
								label: '5x15 Storage Unit',
								key: 'storage5x15',
							},
						],

						rows: [
							{
								dimension: {
									type: 'markdown',
									markdown: '**Floor Space**',
								},
								storage5x15: '75 square feet',
							},
							{
								dimension: {
									type: 'markdown',
									markdown: '**Cubic Feet**',
								},
								storage5x15: '600-750 cubic feet',
							},
							{
								dimension: {
									type: 'markdown',
									markdown: '**Real-World Size**',
								},
								storage5x15:
									'About the size of a deep or large walk-in closet',
							},
							{
								dimension: {
									type: 'markdown',
									markdown: '**Width**',
								},
								storage5x15: '5 feet',
							},
							{
								dimension: {
									type: 'markdown',
									markdown: '**Length**',
								},
								storage5x15: '15 feet',
							},
							{
								dimension: {
									type: 'markdown',
									markdown: '**Ceiling Height**',
								},
								storage5x15: 'Typically 8-10 feet',
							},
						],
					},
				},
			],
		},

		// //         Full Width Table Block
		// // Is a 10x10 or 5x15 Storage Unit Better?
		{
			title: 'Full Width Table',
			background: 'gray',
			modules: [
				{
					type: 'sizeChart',
					id: 'fullWidthTable',
					props: fullWidthTable,
				},
			],
		},

		// three Panel block
		{
			title: 'Three Panel Block',
			modules: [
				{
					type: 'cardBlockContent',
					id: 'threePanelBlock',
					props: threePanelBlock,
				},
			],
		},

		// //         Three Column Table
		// // 5x15 Storage Unit Average Cost
		{
			title: '5x15 Storage Unit Average Cost',
			background: 'gray',
			modules: [
				{
					type: 'sizeChart',
					id: 'threeColumnTable',
					props: threeColumnTable,
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						pageType: 'SGP',
						reviews,
						title: 'Join Others in Using SpareFoot to Find & Compare 5x15 Storage Units',
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: '5x15 Storage Unit Size FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'rv-featured-content',
						title: 'Learn More About Storage Unit Size Options',
						pageType: 'SGP',
						contentCards: [
							{
								title: 'General Storage Advice',
								date: 'August 7, 2025',
								image: FeaturedContent1,
								content:
									'How to Pick the Right Size Self Storage Unit',
								link: 'https://www.sparefoot.com/blog/how-to-pick-the-right-size-storage-unit',
							},
							{
								title: 'General Storage Advice',
								date: 'October 17, 2025',
								image: Postcovers,
								content: 'How Are Storage Units Measured?',
								link: 'https://www.sparefoot.com/blog/how-are-storage-units-measured',
							},
							{
								title: 'General Storage Advice',
								date: 'October 17, 2025',
								image: bike,
								content:
									'What Can You Fit in a 10x10 Storage Unit?',
								link: 'https://www.sparefoot.com/blog/10x10-storage-unit-size-guide',
							},
							{
								title: 'General Storage Advice',
								date: 'October 31, 2025',
								image: featured,
								content:
									'What Can You Fit in a 10x15 Storage Unit?',
								link: 'https://www.sparefoot.com/blog/what-can-you-fit-inside-of-a-10x15-storage-unit',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other SGP',
			modules: [
				{
					type: 'links',
					props: {
						pageType: 'SGP',
						title: 'More Ways to Store',
						cards: ['Kayak', 'Bicycle', '5x10', '10x20'],
					},
				},
			],
		},
		{
			title: 'nearby units',
			background: 'gray',
			noPaddingBottom: true,
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};